module.exports = __webpack_public_path__ + "img/logo-text.b79bf097.svg";